/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdPopupProps } from './type';

export const popupDefaultProps: TdPopupProps = {
  attach: 'body',
  closeOnOverlayClick: true,
  destroyOnClose: false,
  duration: 240,
  overlayProps: {},
  placement: 'top',
  preventScrollThrough: true,
  showOverlay: true,
};
